// core
import React from 'react';
import { Link } from 'react-router-dom';

class OverviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      timeFetching: 0,

      error: ''
    };
  }

  render() {
    const linkStyle = {
      fontSize: '18px'
    };

    const headingLinkStyle = {
      color: '#111'
    };

    if (this.state.error) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="alert alert-danger">
                <h2>Oh, mamma!</h2>
                <p>{this.state.error}</p>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="container">
            <div className="row">
              <div className="col-6">
                <h1><i className="fa fa-graduation-cap" /> Progetti educativi</h1>
              </div>
              <div className="col-6"></div>
            </div>
          </div>

          {/* EDU */}
          <div className="container">
          <div className="row mt-4">
            <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <h3><Link to="/kits/overview/" style={headingLinkStyle}><i className="fa fa-gift" /> Kit + ordini</Link></h3>
                    <p>
                      <Link style={linkStyle} to="/kits/overview/">overview</Link> <small>- panoramica kit + richieste</small>
                    </p>

                    <hr />
                    <p>
                      <Link style={linkStyle} to="/kit-orders/copy-paste/">copia e incolla</Link> <small>- copia richieste da un kit all'altro</small><br />
                      <Link style={linkStyle} to="/tools/miur/">tool MIUR</Link> <small>- assegna codice MIUR a richieste dove manca</small><br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <h3><Link to="/schools/overview/" style={headingLinkStyle}><i className="fa fa-school" /> Scuole</Link></h3>
                    <p>
                      <Link style={linkStyle} to="/schools/overview/">overview</Link> <small>- tutte le scuole</small>
                    </p>

                    <hr />

                    <h3><Link to="/teachers/overview/" style={headingLinkStyle}><i className="fa fa-chalkboard-teacher" /> Insegnanti</Link></h3>
                    <p>
                      <Link style={linkStyle} to="/teachers/overview/">overview</Link> <small>- tutti gli insegnanti</small>
                    </p>

                    {/* <hr />

                    <h3><Link to="/principals/overview/" style={headingLinkStyle}><i className="fa fa-user-tie" /> Dirigenti scolastici</Link></h3>
                    <p>
                      <Link style={linkStyle} to="/principals/overview/">overview</Link> <small>- tutti i dirigenti scolastici</small>
                    </p>                     */}

                    <hr />

                    <h3><Link to="/families/overview/" style={headingLinkStyle}><i className="fa fa-users" /> Famiglie</Link></h3>
                    <p><i className="fa fa-wrench mr-2" />COMING SOON</p>
                    {/* <p>
                      <Link style={linkStyle} to="/families/overview/">overview</Link> <small>- tutti i dati delle famiglie</small>
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-6"></div>
              <div className="col-6">
                <div className="card">
                  <div className="card-body">
                    <h3><Link to="/marketing/surveys/overview/" style={headingLinkStyle}><i className="fa fa-chart-pie" /> Marketing</Link></h3>
                    <p><i className="fa fa-wrench mr-2" />IN MANUTENZIONE</p>
                    {/* <p className="mb-0">
                      <Link style={linkStyle} to="/marketing/surveys/overview/">sondaggi</Link> <small>- scopri cosa pensano gli insegnanti</small>
                    </p>
                    <p className="mt-0">
                      <Link style={linkStyle} to="/marketing/mailings/overview/">mailing</Link> <small>- gestisci spedizioni email massive</small>
                    </p> */}
                  </div>
                </div>

                <div className="card mt-4">
                  <div className="card-body">
                    <h3><i className="fa fa-plus" /> Etc.</h3>
                    <p className="mb-0">
                      <Link style={linkStyle} to="/etc/projects/alpitour-2021/-/">Alpitour 2021</Link> <small>- gestisci dati progetto</small>
                    </p>
                    <p className="mt-0">
                    <Link style={linkStyle} to="/etc/projects/corepla-2020/-/">Corepla 2020</Link> <small>- gestisci dati progetto</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default OverviewPage;


// WEBPACK FOOTER //
// ./src/pages/home/EducationalMainPage.js